import { useTimeZoneConflict } from '@dms/hook'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { Banner, BannerProps, Spacing } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    marginTop: Spacing.M,
  },
})

interface Props extends BannerProps {
  companyId: number
  buildingId?: number
}

const TimeZoneWarning = (props: Props) => {
  const { companyId, buildingId, style, ...otherProps } = props
  const timeZoneConflict = useTimeZoneConflict({ companyId, buildingId })
  const { t } = useTranslation()

  return (
    timeZoneConflict && (
      <Banner
        style={[styles.container, style]}
        message={t(
          'You are currently in a different timezone than the location you are viewing. The data presented here is based on the timezone of the location.',
        )}
        status="warning"
        {...otherProps}
      />
    )
  )
}

export default TimeZoneWarning
